export const getValuationSuggestions = payload => {
  return {
    type: "FETCH_VALUATION_LIST",
    payload
  };
};

export const setValuationSettings = items => {
  return {
    type: "SET_VALUATION_SETTINGS",
    items
  };
};
export const saveValuationSettings = resp => ({
  type: "SAVE_VALUATION_SETTINGS",
  payload: resp
});

export const updateValuationSettings = resp => ({
  type: "UPDATE_VALUATION_SETTINGS",
  payload: resp
});

export const deleteValuationSettings = resp => ({
  type: "DELETE_VALUATION_SETTINGS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/valuation.js